import { types } from 'mobx-state-tree';
import Actions from './Actions';
import Views from './Views';
const PriceIntervalModel = types.model({
    name: types.string,
    unit: types.string,
    value: types.number,
});
const PriceQuotaModel = types.model({
    credits: types.number,
    email: types.number,
    seats: types.number,
    phone: types.number,
});
const PriceBookEntryModel = types.model({
    value: types.number,
    quantity: types.maybe(types.number),
});
const PlanPriceModel = types.model({
    id: types.string,
    amount: types.number,
    active: types.boolean,
    interval: PriceIntervalModel,
    quota: PriceQuotaModel,
    priceBook: types.frozen(),
    isDynamic: types.boolean,
    isAvailableForUpgrade: types.boolean,
    additionalCredits: types.optional(types.number, 0),
    additionalPrice: types.optional(types.number, 0),
    baseCredits: types.optional(types.number, 0),
    basePrice: types.optional(types.number, 0),
    discountPercent: types.optional(types.number, 0),
    dynamicProductPriceId: types.optional(types.string, ''),
    quantity: types.optional(types.number, 0),
    strikethroughPrice: types.optional(types.number, 0),
    totalCredits: types.optional(types.number, 0),
    totalPrice: types.optional(types.number, 0),
});
const PlanProductModel = types.model({
    id: types.string,
    code: types.string,
    name: types.string,
    description: types.string,
});
const PricingPlanModel = types.model({
    id: types.string,
    name: types.string,
    code: types.string,
    prices: types.array(PlanPriceModel),
    products: types.array(PlanProductModel),
    priceBook: types.frozen(),
    isDynamic: types.boolean,
    isAvailableForUpgrade: types.boolean,
});
const QuantityStepModel = types.model({
    quantity: types.number,
    finalPrice: types.number,
    percent: types.number,
});
const DiscountStepModel = types.model({
    discountPercent: types.number,
    fromQuantity: types.number,
});
const SeatAssetModel = types.model({
    value: types.number,
    type: types.string,
    isLimited: types.boolean,
    toDisplay: types.boolean,
    version: types.number,
});
const SeatProductPriceModel = types.model({
    id: types.string,
    amount: types.number,
    active: types.boolean,
    recurring: types.boolean,
    currencyCode: types.string,
    interval: PriceIntervalModel,
    minimumQuantity: types.number,
    maximumAvailableQuantity: types.number,
    quantitySteps: types.array(QuantityStepModel),
    discountSteps: types.array(DiscountStepModel),
    assets: types.frozen(),
});
const SeatProductItemModel = types.model({
    id: types.string,
    code: types.string,
    name: types.string,
    description: types.string,
    category: types.string,
    active: types.boolean,
    prices: types.array(SeatProductPriceModel),
});
const SeatProductModel = types.model({
    planId: types.string,
    planCode: types.string,
    planName: types.string,
    products: types.array(SeatProductItemModel),
});
const PlanFeatureModel = types.model({
    feature: types.string,
    feature_description: types.string,
    feature_icon: types.boolean,
    feature_is_new: types.boolean,
    available_from_version: types.string,
    available_until_version: types.string,
    order: types.string,
});
const PlanFeatureDetailModel = types.model({
    plan_name: types.string,
    presented_name: types.string,
    tagline: types.string,
    features_title: types.string,
    disclaimer: types.string,
    submit_text: types.string,
    features: types.array(PlanFeatureModel),
});
const PlanGroupModel = types.model({
    group_name: types.string,
    version_min: types.string,
    version_max: types.string,
    plans: types.array(PlanFeatureDetailModel),
});
const PricingPlanFeaturesModel = types.model({
    plan_groups: types.array(PlanGroupModel),
});
const ModelProps = {
    isLoaded: types.optional(types.boolean, false),
    isLoading: types.optional(types.boolean, false),
    isModalVisible: types.optional(types.boolean, false),
    pricingVersion: types.maybeNull(types.string),
    openSource: types.maybeNull(types.string),
    experienceMode: types.maybeNull(types.string),
    experimentVariant: types.maybeNull(types.string),
    hierarchyStep: types.maybeNull(types.string),
    isCrossVersionUser: types.optional(types.boolean, false),
    plans: types.optional(types.array(PricingPlanModel), []),
    seatProducts: types.optional(types.array(SeatProductModel), []),
    pricingPlanFeatures: types.maybeNull(PricingPlanFeaturesModel),
};
const Pricing = types.model(ModelProps).actions(Actions).views(Views);
export default Pricing;
